import { render, staticRenderFns } from "./SimpleCardContent.vue?vue&type=template&id=1f022dee&"
import script from "./SimpleCardContent.vue?vue&type=script&lang=ts&"
export * from "./SimpleCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports